import { Http } from 'src/shared/services/Http';

import { ProgramEnum, ProgramWeekEnum } from '../../models/programs';
import { programWeekNumberById } from '../../models/programsData';
import {
    FetchedProgramFeedback,
    FetchedWeekFeedback,
    FetchWeekFeedbackData,
    ProgramFeedback,
    SubmitFeedbackData,
    WeekFeedback,
} from '../models/feedback';

export class FeedbackService {
    constructor(private http: Http) {}

    public getWeekFeedbackUrl = (programId: ProgramEnum, weekId: ProgramWeekEnum) =>
        Object.values(ProgramEnum).includes(programId) &&
        Object.values(ProgramWeekEnum).includes(weekId)
            ? `programs/${programId}/weeks/${programWeekNumberById[weekId]}/feedback/`
            : undefined;

    public getProgramFeedbackUrl = (programId: ProgramEnum) =>
        Object.values(ProgramEnum).includes(programId)
            ? `programs/${programId}/feedback/`
            : undefined;

    public async fetchWeekFeedback(data: FetchWeekFeedbackData): Promise<FetchedWeekFeedback> {
        const { programId, weekId } = data;

        const url = this.getWeekFeedbackUrl(programId, weekId);

        if (!url) {
            Promise.reject('wrong program id or week id');
        }

        const feedback = await this.http.GET<WeekFeedback>(url!);

        return {
            programId,
            weekId,
            feedback,
        };
    }

    public async fetchProgramFeedback(programId: ProgramEnum): Promise<FetchedProgramFeedback> {
        const url = this.getProgramFeedbackUrl(programId);

        if (!url) {
            Promise.reject('wrong program id');
        }

        const feedback = await this.http.GET<ProgramFeedback>(url!);

        return {
            programId,
            feedback,
        };
    }

    public submitFeedback(data: SubmitFeedbackData): Promise<WeekFeedback | ProgramFeedback> {
        const { programId, weekId, feedback } = data;

        if (!weekId) {
            const programUrl = this.getProgramFeedbackUrl(programId);

            if (!programUrl) {
                Promise.reject('wrong program id');
            }

            return this.http.PUT<ProgramFeedback>(programUrl!, feedback);
        }

        const weekUrl = this.getWeekFeedbackUrl(programId, weekId);

        if (!weekUrl) {
            Promise.reject('wrong program or week id');
        }

        return this.http.PUT<WeekFeedback>(weekUrl!, feedback);
    }
}
